import { useEffect, useState } from 'react';
import { getSettings } from '../api/settingsApi';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

function Footer() {
    const [settings, setSettings] = useState({});

    useEffect(() => {
        getSettings().then(res => setSettings(res.data)).catch(() => {});
    }, []);

    return (
        <footer className={styles.footer}>
            <div className={styles.inner}>
                <p className={styles.shopName}>{settings.shop_name || 'SHOP'}</p>
                <div className={styles.policyLinks}>
                    <Link to="/privacy" className={styles.policyLink}>개인정보처리방침</Link>
                    <span className={styles.divider}>|</span>
                    <Link to="/terms" className={styles.policyLink}>이용약관</Link>
                </div>
                <div className={styles.info}>
                    {settings.shop_owner && (
                        <span>대표자: {settings.shop_owner}</span>
                    )}
                    {settings.shop_business_number && (
                        <span>사업자등록번호: {settings.shop_business_number}</span>
                    )}
                    {settings.shop_trade_number && (
                        <span>통신판매업 신고번호: {settings.shop_trade_number}</span>
                    )}
                    {settings.shop_address && (
                        <span>주소: {settings.shop_address}</span>
                    )}
                    {settings.shop_phone && (
                        <span>대표전화: {settings.shop_phone}</span>
                    )}
                    {settings.shop_email && (
                        <span>이메일: {settings.shop_email}</span>
                    )}
                </div>
                <p className={styles.copyright}>
                    © {new Date().getFullYear()} {settings.shop_name || 'SHOP'}. All rights reserved.
                </p>
            </div>
        </footer>
    );
}

export default Footer;